import React from 'react';
import { CheckIcon, ChevronDownIcon } from '../../styled/Icon';
import {
  DropdownHeader,
  DropdownItem,
  DropdownIcon,
  CheckIconWrapper,
  DropdownList,
} from '../../styled/Cart/Dropdown';
import clsx from 'clsx';
import useDropdownMenu from '../DropdownMenu/useDropdownMenu';
import DropdownMenu from '../DropdownMenu';
import QuantityDropdownInput from './QuantityDropdownInput';

interface IQuantityProps {
  disabled: boolean;
  quantity: any;
  onChange: (arg: number) => void;
}

interface IItem {
  text: string;
  value: number;
  active: boolean;
}

interface IQuantityDropdownItem {
  onClick: (value: number) => void;
  item: IItem;
}

const QuantityDropdownItem = ({ onClick, item }: IQuantityDropdownItem) => {
  return (
    <DropdownItem onClick={() => onClick(item.value)} key={item.text}>
      <CheckIconWrapper>{item.active ? <CheckIcon strokeWidth="2" /> : null}</CheckIconWrapper>
      {item.text}
    </DropdownItem>
  );
};

const QuantityDropdown = ({ disabled, quantity, onChange }: IQuantityProps) => {
  const { showMenu, toggleShowMenu, bodyRef } = useDropdownMenu();
  /**
   * @desc Array For item Quantity
   */
  const items: IItem[] = [];
  for (let i = 1; i < 10; i++) {
    items.push({
      text: i.toString(),
      value: i,
      active: i === quantity,
    });
  }
  items.push({
    text: '10+',
    value: 10,
    active: quantity >= 10,
  });

  const handleItemClick = (value: number) => {
    onChange(value);
    toggleShowMenu();
  };

  return (
    <>
      {!items[items.length - 1].active ? (
        <div ref={bodyRef}>
          <DropdownHeader
            className={clsx(disabled && 'disabled')}
            onClick={() => (!disabled && toggleShowMenu()) || undefined}
            ref={bodyRef}>
            <DropdownIcon>
              {quantity}
              {!disabled && <ChevronDownIcon strokeWidth="2" />}
            </DropdownIcon>
          </DropdownHeader>
          {showMenu && (
            <DropdownMenu onClose={() => toggleShowMenu()}>
              <DropdownList>
                {items.map((item) => (
                  <QuantityDropdownItem key={item.text} onClick={handleItemClick} item={item} />
                ))}
              </DropdownList>
            </DropdownMenu>
          )}
        </div>
      ) : (
        <QuantityDropdownInput disabled={disabled} quantity={quantity} onChange={onChange} />
      )}
    </>
  );
};
export default QuantityDropdown;
